/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - USER STATUS BADGES: STYLES --------------- ++++++++++ */
export default theme => ({
  userstatusbadges: {
  }
});
